import React from 'react';
import InlineLinkLists from './InlineLinkLists';
import LogosRow from './LogosRow';
import classnames from 'classnames';
import { t } from '../i18n';
/**
 * For information about how and when to use this component,
 * [refer to its full documentation page](https://design.cms.gov/components/footer/healthcare-footer/?theme=healthcare).
 */
export var Footer = function Footer(props) {
  var classes = classnames('hc-c-footer', props.className);
  return /*#__PURE__*/React.createElement("footer", {
    className: classes,
    role: "contentinfo"
  }, props.footerTop, /*#__PURE__*/React.createElement(InlineLinkLists, {
    t: t,
    primaryDomain: props.primaryDomain
  }), /*#__PURE__*/React.createElement(LogosRow, {
    t: t
  }));
};
export default Footer;